import { render, staticRenderFns } from "./MySignature.vue?vue&type=template&id=631e822d&scoped=true"
import script from "./MySignature.vue?vue&type=script&lang=js"
export * from "./MySignature.vue?vue&type=script&lang=js"
import style0 from "./MySignature.vue?vue&type=style&index=0&id=631e822d&prod&lang=scss&scoped=true"
import style1 from "./MySignature.vue?vue&type=style&index=1&id=631e822d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e822d",
  null
  
)

export default component.exports